// Project ID format: P followed by 27 or 31 alphanumeric characters
export const projectRegex = /^P([a-zA-Z0-9]{27}|[a-zA-Z0-9]{31})$/;
